<script lang="ts">
  import { page } from "$app/stores";
  import { Breadcrumb, BreadcrumbItem } from "flowbite-svelte";
  import ChevronRight from "virtual:icons/mdi/chevron-right";

  function generateFrontendBreadcrumbItems(path: string) {
    if (!path) return [];

    const segments = path.split("/").filter(Boolean);
    const items = [];

    items.push({
      name: "CasinoFeber",
      path: "/",
      isHome: true,
      isCurrent: segments.length === 0,
    });

    let currentPath = "";
    segments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const isLast = index === segments.length - 1;

      items.push({
        name: segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, " "),
        path: isLast ? "" : currentPath,
        isHome: false,
        isCurrent: isLast,
      });
    });

    return items;
  }

  $: breadcrumbItems = generateFrontendBreadcrumbItems($page.url.pathname);
</script>

<div class="content-grid">
  <div class="full-width bg-brand py-2">
    <Breadcrumb
      aria-label="Breadcrumb"
      solid={false}
      class="!p-0"
      olClass="flex items-center text-white"
      divClass="mx-1 text-white fill-white">
      {#each breadcrumbItems as item, index}
        {#if index === 0}
          <!-- First item (no divider before it) -->
          <BreadcrumbItem
            href={item.isCurrent ? undefined : item.path}
            class="!pl-0 inline-flex items-center"
            linkClass="text-white font-light text-sm hover:text-gray-200"
            spanClass="text-white text-sm font-bold"
            icon=""
            home={false}>
            <svelte:fragment slot="icon"><ChevronRight class="hidden" /></svelte:fragment>
            {item.name}
          </BreadcrumbItem>
        {:else}
          <!-- Other items (with divider styling) -->
          <BreadcrumbItem
            href={item.isCurrent ? undefined : item.path}
            linkClass="text-white font-light text-sm hover:text-gray-200"
            spanClass="text-white text-sm font-bold"
            icon=""
            home={false}>
            <svelte:fragment slot="icon"><ChevronRight class="w-5 h-5 mx-2 dark:text-white" /></svelte:fragment>
            {item.name}
          </BreadcrumbItem>
        {/if}
      {/each}
    </Breadcrumb>
  </div>
</div>
